module.exports = "/images/er.svg?9df537b4d40781081f7325eda3d2dd14";